const ANON_ID_KEY = 'solomon_anon_id';

function getAnonymousId(): string {
  let id = localStorage.getItem(ANON_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(ANON_ID_KEY, id);
  }
  return id;
}

export const track = (name: string, props?: object) => {
  fetch('/api/analytics/track', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      event: name,
      properties: props,
      anonymousId: getAnonymousId(),
    }),
  }).catch(() => {
    // Silently fail - don't block user interactions
  });
};
